<template>
  <span
    class="indicator-tooltip-wrapper d-inline-block align-middle ml-1"
    @mousedown.stop
    @click.stop
  >
    <b-icon-info-circle-fill
      class="indicator-info-icon"
      role="button"
      tabindex="0"
      :aria-label="'Open details for indicator ' + indicatorId"
      @mousedown.stop.prevent="openExplanation"
      @click.stop.prevent="openExplanation"
      @keydown.enter.prevent="openExplanation"
      @keydown.space.prevent="openExplanation"
      @touchstart.stop.prevent="openExplanation"
    />
  </span>
</template>

<script>
import { eventBus } from '@/main';

const OPEN_EVENT = 'open-indicator-explanation';

export default {
  name: 'IndicatorExplanationTooltip',
  props: {
    indicatorId: {
      type: [String, Number],
      required: true,
    },
  },
  methods: {
    openExplanation() {
      const id = this.indicatorId;
      eventBus.$emit(OPEN_EVENT, id);
      this.$root.$emit(OPEN_EVENT, id);
    },
  },
};
</script>

<style scoped>
.indicator-tooltip-wrapper {
  display: inline-flex;
  align-items: center;
  position: relative;
  z-index: 1;
}

.indicator-info-icon {
  font-size: 15.5px;
  color: #348481 !important;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-left: 5px;
}

.indicator-info-icon:hover,
.indicator-info-icon:focus {
  opacity: 0.8;
  outline: none;
}
</style>
